/*
 * Copyright (c) 2020 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AbstractControlValueAccessorControl } from './abstract-control-value-accessor-control';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive()
export abstract class AbstractControlValueAccessorGroup extends AbstractControlValueAccessorControl {
  declare form: UntypedFormGroup | FormGroup<{ [key: string]: any }>;

  protected constructor() {
    super();
  }

  writeValue(obj: any): void {
    if (obj) {
      this.form.setValue(obj, { emitEvent: false });
    }
  }
}
